import React from 'react';
import ReactGA from 'react-ga';
import GIECard from '../../components/GIECard/GieCard';
import GIETextField from '../../components/GIETextField/GieTextField';
import GIEButton from '../../components/GIEButton/GieButton';
import {FormValidator} from '../../util/form-validator';
import LoginController from '../../controller/login.controller';
import GIELink from "../../components/GIELink/GIELink";

export default class PasswordForget extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  loginController: LoginController = new LoginController();

  constructor(props) {
    super(props);
    this.state = {
      formControls: {
        noContract: {
          value: '',
          error: false,
          errorMessage: ''
        }
      },
      emailSend: false
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value,
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    });
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;
      if (error.error === true) {
        isError = true
      }
    });
    this.setState(formControls)
    return isError;
  }

  sendEmail = () => {
    if (!this.checkValidForm()) {
      const request = {
        noContract: this.state.formControls.noContract.value
      }
      this.loginController.sendTokenToRegeneratePassword(request).then(data => {
        this.setState({emailSend: true})
      }).catch(err => {
        this.manageError(err)
        console.log(err)
      })
    }
  }

  manageError = (err) => {
    console.log(err)
    let formControls = this.state.formControls;
    if (err && err.response && err.response.status === 404) {
      formControls.noContract.error = true;
      formControls.noContract.errorMessage = "Il n'y a pas de compte portant ce numéro"
    } else {
      formControls.noContract.error = true;
      formControls.noContract.errorMessage = "Une erreur s'est produite"
    }
    this.setState({formControls})
  }

  render() {
    const emailNotSent = this.state.emailSend === false;
    return (
      <div className="content">
        <div className="blue-bg-container">
          <div className="m-auto">
            <GIECard width="500px" height="100%">
              <div className="p-4">
                <h2 className="text-center">Mot de passe oublié</h2>
                <div className="my-5">
                  <GIETextField label="Votre n° de contrat"
                                required
                                onChange={this.changeHandler}
                                name="noContract"
                                value={this.state.formControls.noContract.value}
                                helperText={this.state.formControls.noContract.errorMessage}
                                error={this.state.formControls.noContract.error}/>
                  {emailNotSent ? null : (<span>Un mail vous a été envoyé pour modifier votre mot de passe.</span>)}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <GIELink href="/admin/login" arrowBefore>Retour</GIELink>
                  {emailNotSent ? (
                    <GIEButton onClick={this.sendEmail} classes={{root: 'orange-btn'}}>Valider</GIEButton>) : null}
                </div>
              </div>
            </GIECard>
          </div>
        </div>
      </div>
    );
  }
}
